module.exports = __webpack_public_path__ + "img/ic-warning.4c37adc0.svg";